export default {
  language: (state) => state.app.language,
  pathFlag: (state) => state.user.pathFlag,
  pathParams: (state) => state.user.pathParams,
  globalUserInfo: (state) => state.user.globalUserInfo,
}
